module.exports = __webpack_public_path__ + "static/media/sGrAdd.6a03c946.png";